import { Typography } from "../../../../../../shared/frontend/ui";
import React from "react";
import { useAuth } from "../../app/auth/useAuth";
import { useI18n } from "../../app/i18n/useI18n";
import { areaAccessContextFromAuth, areaCards, communicationArea } from "../../app/navigation/areaCatalog";
import { NavCardGrid } from "../../components/NavCardGrid";

const { Text } = Typography;

export function CommunicationHomePage() {
  const { text } = useI18n();
  const auth = useAuth();

  // Karten, Menü und Router-Guards lesen denselben Bereichskatalog.
  const items = React.useMemo(() => areaCards(communicationArea, areaAccessContextFromAuth(auth.info)), [auth.info]);

  if (items.length === 0) {
    return (
      <NavCardGrid title={text("Communication")} text={text} empty={<Text type="secondary">{text("No permissions available")}</Text>} />
    );
  }

  return (
    <NavCardGrid title={text("Communication")} items={items} text={text} />
  );
}
